export var GA_PLATFORM;
(function (GA_PLATFORM) {
    GA_PLATFORM["FS_AP"] = "FSAP";
    GA_PLATFORM["FS_PC"] = "FSPC";
    GA_PLATFORM["QC_AP"] = "QCAP";
    GA_PLATFORM["QC_PC"] = "QCPC";
})(GA_PLATFORM || (GA_PLATFORM = {}));
